import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { FgDmagesService } from './fg-damages-service';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { FgDamagesDto } from './dto/fg-damages-dto';
import { FgIdRequest, unitIdRequest } from './dto/plant-request';
import { FgDamagesResponseModel } from '@gtpl/shared-models/warehouse-management';

@ApiTags('fgdamages')
@Controller('fgdamages')

export class FgDamagesController{
    constructor(
      private fgdamgesservice:FgDmagesService,
      private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createFgDamgesReason')
    async createFgDamgesReason(@Body() Dto:FgDamagesDto,isUpdate:boolean=false): Promise<CommonResponse> {
    try {
        return await this.fgdamgesservice.createFgDamgesReason(Dto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }
    @Post('/updateFgdamages')
    async updateFgdamages(@Body() Dto: FgDamagesDto): Promise<CommonResponse> {
      try {
        return await this.fgdamgesservice.createFgDamgesReason(Dto, true);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }
    @Post('/getLocationforDamages')
    async getLocationforDamages(@Body() req:unitIdRequest): Promise<CommonResponse> {
      try {
        return await this.fgdamgesservice.getLocationforDamages(req);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }
    @Post('/getsaleorderagainstlocation')
    async getsaleorderagainstlocation(@Body() req:unitIdRequest): Promise<CommonResponse> {
      try {
        return await this.fgdamgesservice.getsaleorderagainstlocation(req);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }
    
    @Post('/getAllfgDamagesData')
    async getAllfgDamagesData(@Body() req:unitIdRequest): Promise<CommonResponse> {
      try {
        return await this.fgdamgesservice.getAllfgDamagesData(req);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }
    @Post('/getallLocationSaleorderandProduct')
    async getallLocationSaleorderandProduct(@Body() req:unitIdRequest): Promise<CommonResponse> {
      try {
        return await this.fgdamgesservice.getallLocationSaleorderandProduct(req);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }
           
    @Post('/activateOrDeactivateDamges')
    async activateOrDeactivateDamges(@Body() req: FgIdRequest): Promise<FgDamagesResponseModel> {
        try {
            return await this.fgdamgesservice.activateOrDeactivateDamges(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(FgDamagesResponseModel, err);
        }
    }
}
